var map = {
	"./bash": 1759,
	"./java": 1760,
	"./json": 1761,
	"./julia": 1762,
	"./python": 1763,
	"./r": 1764,
	"./rust": 1765,
	"./scala": 1766,
	"./shell": 1767,
	"./sql": 1768,
	"./xml": 1769,
	"./yaml": 1770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1758;